import React from 'react';
import { message, Modal, Layout, Button, Row, Col, Card, Typography, Spin, Space, Statistic, Alert, Divider } from 'antd';
import { HddOutlined, CopyOutlined } from '@ant-design/icons';
import { useMediaQuery } from 'react-responsive'
import evmLib from '../evmLib';
import feathersLib from '../feathersLib';
import Lib from '../Lib';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import moment from 'moment';
import LPVault from './LPVault';
import PoSVault from './PoSVault';
import ZoVault from './ZoVault';
import NFTOwned from './NFTOwned';

const { Title, Text, Paragraph } = Typography;
const { Footer, Content } = Layout;
const {
  TOKEN,
  GAS,
  DEX,
  CHAIN_NAME,
  TRADE_LINK,
  FORUM_LINK,
  TWITTER_LINK,
  TELEGRAM_LINK,
  TOKEN_LINK,
  NFT_LINK,
  CHART_LINK,
  DEXTOOLS,
  EXPLORER_TX,
  LP_LINK
} = require('../config');

const Mobile = ({ children }) => {
  const isMobile = useMediaQuery({ maxWidth: 767 })
  return isMobile ? children : null
}
const Default = ({ children }) => {
  const isNotMobile = useMediaQuery({ minWidth: 768 })
  return isNotMobile ? children : null
}

function shortHex(hexStr) {
  const ret = hexStr.slice(0, 9) + '...' + hexStr.slice(hexStr.length - 7);
  return ret;
}

function to5digit(val) {
  return Math.floor(Number(val) * 100000) / 100000;
}

let OUT;

class Dashboard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showDisclaimer: true,
      metamaskStatus: 'busy',
      busyData: true,
      busyDataOwned: true,
      stakeAmount: '',
      posVaultError: false,
      minterError: false
    };
  }
  async componentDidMount() {
    await this.refreshData();
    await this.connectWallet();
  }

  async refreshData() {
    this.setState({ busyData: true });
    const publicData = await feathersLib.getPublicData();
    this.setState(publicData);
    const blockchainTime = await evmLib.getBlockchainTime();
    this.setState({ blockchainTime });
    this.setState({ busyData: false });
  }

  async connectWallet() {
    this.setState({ metamask: null, metamaskStatus: 'busy' });
    try {
      const check = await evmLib.detectMetamask();
      if (check) {
        const metamask = await evmLib.loadMetamask();
        this.metamask = metamask;
        this.metamask.address = await this.metamask.getSigner().getAddress();
        this.setState({ metamask, metamaskStatus: 'connected' });
      }
    } catch (err) {
      const msg1 = 'Please install Metamask and reload!';
      const msg2 = 'Please connect Metamask to Conflux eSpace!';

      if (err.message) {
        const msg = err.message;
        if (msg === msg1 || msg === msg2)
          this.setState({ metamaskError: err.message });
        else
          this.setState({ metamaskError: 'Please install Metamask and reload!' });
      }
      this.setState({ metamaskStatus: 'disconnected' });
    }

    this.wallet = await evmLib.loadWalletRandom();
    await this.refreshData();
    await this.refreshPosVaultData();
    if (this.metamask) {
      await this.refreshPosVaultDataUser();
    }

  }

  async refreshPosVaultData() {
    this.setState({ posVaultData: null });
    const posVaultData = await evmLib.getPosVaultData();
    this.setState({ posVaultData });
  }

  async refreshPosVaultDataUser() {
    this.setState({ posVaultDataUser: null });
    const wallet = this.metamask.getSigner();
    wallet.address = this.metamask.address;
    const posVaultDataUser = await evmLib.getPosVaultDataUser(wallet);
    this.setState({ posVaultDataUser });
  }

  componentWillUnmount() {
  }

  goto(page) {
    this.props.history.push(page);
  }

  async mintNFT(amountCoin) {
    if (!this.metamask) {
      return message.error('not connected to metamask');
    }

    const amountWei = evmLib.eth2wei(amountCoin + '');
    const balance = await evmLib.getWalletBalance(this.metamask.address);

    if (balance.lt(amountWei))
      return this.setState({ minterError: 'Wallet dont have enough CFX. Buy CFX at Swappi.' });

    try {
      this.setState({ showTxPopup: true, txHash: false, txStatus: 'waiting' });
      const amount = evmLib.eth2wei(amountCoin + '').toString();
      let tx = await evmLib.mintNFT(this.metamask.getSigner(), amount, 1);
      this.setState({ txHash: tx.hash });
      await tx.wait();

      let refreshNum = this.state.refreshNum ? this.state.refreshNum : 0;
      refreshNum++;
      await Lib.delay(500);
      this.setState({ refreshNum });

      this.setState({ txStatus: 'confirmed' });
    } catch (err) {
      this.setState({ txStatus: 'fail' });
    }
  }

  gotoDex() {
    Lib.openUrlHere(TRADE_LINK);
  }

  gotoForum() {
    Lib.openUrlHere(FORUM_LINK);
  }

  gotoTwitter() {
    Lib.openUrlHere(TWITTER_LINK);
  }

  gotoTelegram() {
    Lib.openUrlHere(TELEGRAM_LINK);
  }

  async copyToClipboard() {
    const tokenAddress = evmLib.TOKEN_ADDRESS;
    await Lib.copyToClipboard(tokenAddress);
  }

  async addTokenToMetamask() {
    await evmLib.addTokenToMetamask();
  }

  renderHero() {
    const msg = 'Yield optimizer for native coin. Deployed on Conflux eSpace & traded as TXT/CFX on Swappi';
    return (
      <div style={{ width: '100%', height: '100%', padding: '5vh', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
        <Title style={{ textAlign: 'center' }} level={2}>TRADERBOT X</Title>
        <Text style={{ textAlign: 'center' }}>{msg}</Text>
      </div>
    );
  }

  renderStat() {
    const xs = 24;
    const sm = 12;

    const tokenAddress = evmLib.TOKEN_ADDRESS;
    const shortTokenAddress = tokenAddress.slice(0, 9) + '...' + tokenAddress.slice(tokenAddress.length - 7);

    function toPrice(val) {
      const ret = val ? Math.floor(Number(val) * 1000000) / 1000000 : '-';
      return ret;
    }

    const currentPrice = toPrice(this.state.currentPrice) + ' ' + GAS;
    let athPctg = ' (' + (this.state.athPctg >= 0 ? this.state.athPctg : '-') + ' %)';
    let atlPctg = ' (' + (this.state.atlPctg >= 0 ? this.state.atlPctg : '-') + ' %)';
    if (this.state.athPctg) {
      if (this.state.athPctg > 0) athPctg = ' (+' + this.state.athPctg + ' %)';
      else athPctg = ' (' + this.state.athPctg + ' %)';
    }
    if (this.state.atlPctg) {
      if (this.state.atlPctg > 0) atlPctg = ' (+' + this.state.atlPctg + ' %)';
      else atlPctg = ' (' + this.state.atlPctg + ' %)';
    }
    const ATH = toPrice(this.state.athPrice) + ' ' + GAS + athPctg;
    const ATL = toPrice(this.state.atlPrice) + ' ' + GAS + atlPctg;
    const pc1 = '' + (this.state.pctg1 ? this.state.pctg1 : '-') + ' %';
    const pc7 = '' + (this.state.pctg7 ? this.state.pctg7 : '-') + ' %';
    const pc30 = '' + (this.state.pctg30 ? this.state.pctg30 : '-') + ' %';
    const pc365 = '' + (this.state.pctg365 ? this.state.pctg365 : '-') + ' %';

    let btn = <span />;

    const nftMinted = this.state.nftMinted ? this.state.nftMinted : '-';
    let nftGenerated = this.state.nftGenerated ? Math.floor(this.state.nftGenerated) : '-';
    nftGenerated = nftGenerated + ' ' + TOKEN;

    let out = [];
    out.push('Traderbot X Daily Stat (' + moment().format('DD/MM/YYYY') + ')');
    out.push('current price: ' + currentPrice);
    out.push('from ATH: ' + ATH);
    out.push('from ATL: ' + ATL);
    out.push('nft minted: ' + nftMinted);
    out.push('earned by nft: ' + nftGenerated);
    out = out.join('\n');
    if (OUT !== out) {
      OUT = out;
      console.log(out);
    }


    const renderTitle = (
      <Row>
        <Col span={24}>
          <Mobile>
            <Space align='center' direction='vertical' style={{ width: '100%' }}>
              <Text>Traderbot X Token (TXT)</Text>
              {btn}
            </Space>
          </Mobile>
          <Default>
            <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center' }}>
              <Text>Traderbot X Token (TXT)</Text>
              {btn}
            </div>
          </Default>
        </Col>
      </Row>
    );

    return (
      <Card title={renderTitle} style={{ height: '100%' }} headStyle={{}}>
        <Row gutter={[8, 8]}>
          <Col xs={xs} sm={sm}>
            <Statistic title="Address" value={shortTokenAddress} suffix={
              <CopyToClipboard text={tokenAddress} onCopy={() => message.info('address copied to clipboard')}>
                <Button type='link' icon={<CopyOutlined />} />
              </CopyToClipboard>
            } />
          </Col>
          <Col xs={xs} sm={sm}>
            <Statistic title="Current Price" value={currentPrice} />
          </Col>
          <Col xs={xs} sm={sm}>
            <Statistic title="All Time High" value={ATH} />
          </Col>
          <Col xs={xs} sm={sm}>
            <Statistic title="All Time Low" value={ATL} />
          </Col>
          {/* <Col xs={xs} sm={sm}>
            <Statistic title="Price Change D-1" value={pc1} />
          </Col>
          <Col xs={xs} sm={sm}>
            <Statistic title="Price Change D-7" value={pc7} />
          </Col>
          <Col xs={xs} sm={sm}>
            <Statistic title="Price Change D-30" value={pc30} />
          </Col>
          <Col xs={xs} sm={sm}>
            <Statistic title="Price Change Y-1" value={pc365} />
          </Col> */}
          <Col xs={xs} sm={sm}>
            <Statistic title="Minted NFT" value={nftMinted} />
          </Col>
          <Col xs={xs} sm={sm}>
            <Statistic title="Earned by NFT" value={nftGenerated} />
          </Col>
          <Col xs={24} sm={8}>
            <Button type='primary' block onClick={() => this.gotoDex()}>{'TRADE ' + TOKEN + ' ON ' + DEX}</Button>
          </Col>
          <Col xs={24} sm={8}>
            <Button type='primary' block onClick={() => Lib.openUrlHere(CHART_LINK)}>{'VIEW CHART ON ' + DEXTOOLS}</Button>
          </Col>
          <Col xs={24} sm={8}>
            <Button type='primary' block onClick={() => Lib.openUrlHere(LP_LINK)}>{'ADD LIQUIDITY FOR CFX/TXT'}</Button>
          </Col>
          <Col xs={24} sm={8}>
            <Button block onClick={() => this.addTokenToMetamask()}>{'ADD ' + TOKEN + ' INTO METAMASK'}</Button>
          </Col>
          <Col xs={24} sm={8}>
            <Button block onClick={() => Lib.openUrlHere(TOKEN_LINK)}>VERIFY TOKEN CONTRACT</Button>
          </Col>
          <Col xs={24} sm={8}>
            <Button block onClick={() => Lib.openUrlHere(NFT_LINK)}>VERIFY NFT CONTRACT</Button>
          </Col>
        </Row>
      </Card>
    );
  }

  renderTop() {
    let btnMetamask = <Spin />;
    let errMetamask;

    if (this.state.metamaskStatus === 'connected') {
      btnMetamask = (
        <Button type="primary" onClick={() => {
          this.connectWallet();
          window.location.reload();
        }}>
          CONNECTED TO {CHAIN_NAME}
        </Button>
      );

    } else if (this.state.metamaskStatus === 'disconnected') {
      btnMetamask = (
        <Button type="primary" onClick={() => {
          this.connectWallet();
          window.location.reload();
        }}>
          CONNECT METAMASK
        </Button>
      );

      if (this.state.metamaskError) {
        errMetamask = <Alert message={this.state.metamaskError} type="error" />;
      }
    }

    const links = (
      <Space split={<Divider type="vertical" />}>
        <Typography.Link onClick={() => this.gotoTwitter()}>Twitter</Typography.Link>
        <Typography.Link onClick={() => this.gotoTelegram()}>Telegram</Typography.Link>
        <Typography.Link onClick={() => this.gotoForum()}>Forum</Typography.Link>
      </Space>
    );

    return (
      <Row>
        <Col span={24}>
          <Mobile>
            <Space align='center' direction='vertical' style={{ width: '100%' }}>
              {btnMetamask}
              {errMetamask}
              {links}
            </Space>
          </Mobile>
          <Default>
            <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center' }}>
              {links}
              <Space direction='horizontal'>
                {errMetamask}
                {btnMetamask}
              </Space>
            </div>
          </Default>
        </Col>
      </Row>
    );
  }

  renderModal() {
    return (
      <Modal title={'DISCLAIMER'} visible={this.state.showDisclaimer} centered={true} footer={[
        <Button key="back" onClick={() => this.setState({ showDisclaimer: false })}>
          I Understand
        </Button>,
      ]}>
        <Title level={3}>No Investment Advice</Title>
        <Paragraph>
          The information provided on this website does not constitute investment advice, financial advice, trading advice, or any other sort of advice and you should not treat any of the website's content as such. Traderbot X does not recommend that any cryptocurrency should be bought, sold, or held by you. Do conduct your own due diligence and consult your financial advisor before making any investment decisions.
        </Paragraph>

        <Title level={3}>Do Your Own Research</Title>
        <Paragraph>
          TXT Token, TBOTX NFT, PoS VAULT, ZO VAULT, and LP VAULT are open sourced and verified in Confluxscan. Use at your own risk! We assumes no responsibility or liability if there is a bug in the source code.
        </Paragraph>
      </Modal>
    );
  }

  renderModalTx() {

    const wording = this.state.txStatus ? this.state.txStatus.toUpperCase() : 'OK';
    let linkToExplorer = <Spin />;
    if (this.state.txHash) {
      const txHash = this.state.txHash;
      const shortTxHash = shortHex(txHash);
      const url = EXPLORER_TX + txHash;
      linkToExplorer = (
        <Space direction='vertical' align='center'>
          <Text>{shortTxHash}</Text>
          <Button type='link' onClick={() => Lib.openUrlHere(url)}>VIEW ON EXPLORER</Button>
        </Space>
      );
    }

    return (
      <Modal title={'TRANSACTION'} visible={this.state.showTxPopup} centered={true} footer={[
        <Button key="back" onClick={() => this.setState({ showTxPopup: false })}>
          {wording}
        </Button>,
      ]}>
        <div style={{ textAlign: 'center' }}>
          {linkToExplorer}
        </div>
      </Modal>
    );
  }

  render() {
    return (
      <Layout>
        {this.renderModal()}
        {this.renderModalTx()}
        <Content style={{ padding: 16, overflowX: 'hidden' }}>
          <Row justify="center"><Col xs={24} sm={24} md={24} lg={24} xl={24} xxl={20}>
            <Row style={{}} gutter={[8, 8]}>
              <Col xs={24} sm={24}>
                {this.renderTop()}
              </Col>
              <Col span={24} style={{}}>
                {this.renderHero()}
              </Col>
              <Col span={24} style={{}}>
                {this.renderStat()}
              </Col>
              <Col xs={24} sm={12}>
                <PoSVault metamask={this.state.metamask} />
              </Col>
              {/* <Col xs={24} sm={8}>
                <ZoVault metamask={this.state.metamask} />
              </Col> */}
              <Col xs={24} sm={12}>
                <LPVault metamask={this.state.metamask} />
              </Col>
              <Col span={24}>
                {this.renderMinter()}
              </Col>
              <Col span={24}>
                <NFTOwned metamask={this.state.metamask} refreshNum={this.state.refreshNum} />
              </Col>
            </Row>
          </Col></Row>
        </Content>
        <Footer style={{ textAlign: 'center' }}>
          <Text>#traderbotx 2022 v2.5.1</Text>
        </Footer>
      </Layout>
    );
  }

  renderMinter() {
    const avgPPS = this.state.avgProfitPerShare ? Number(this.state.avgProfitPerShare) : 0;
    let estDailyToken = 10 * avgPPS;
    const rows = [
      { title: 'TBOTX T-0', share: 10, price: 50, estDailyProfit: to5digit(10 * avgPPS) },
      { title: 'TBOTX T-1', share: 100, price: 500, estDailyProfit: to5digit(100 * avgPPS) },
      { title: 'TBOTX T-2', share: 1000, price: 5000, estDailyProfit: to5digit(1000 * avgPPS) },
      { title: 'TBOTX T-3', share: 10000, price: 50000, estDailyProfit: to5digit(10000 * avgPPS) }
    ];

    let priceToken = '-';
    let estDailyTokenCFX = '-';
    let estROI = '-';
    function toPrice(val) {
      const ret = val ? Math.floor(Number(val) * 1000000) / 1000000 : 0;
      return ret;
    }

    const currentPrice = toPrice(this.state.currentPrice);

    if (currentPrice > 0) {
      priceToken = currentPrice;
      estDailyTokenCFX = estDailyToken * priceToken;
      estROI = Math.round((50 / estDailyTokenCFX));

      priceToken = to5digit(priceToken);
      estDailyToken = to5digit(estDailyToken);
      estDailyTokenCFX = to5digit(estDailyTokenCFX);
    }

    let minterError;
    if (this.state.minterError) {
      const msg = this.state.minterError;
      minterError = (<Col xs={24}><Alert message={msg} type="error" closable onClose={() => this.setState({ minterError: false })} /></Col>);
    }

    return (
      <Card title={<Title level={4}>Traderbot X NFT</Title>} style={{ height: '100%' }} headStyle={{ textAlign: 'center' }}>
        <Row gutter={[8, 8]} align='middle'>
          <Col xs={24}>
            <p style={{ textAlign: 'center' }}>Own Traderbot X NFT and receive token daily. NFTs maximum supply limited to 8888.</p>
          </Col>
          <Col xs={24} sm={12}>
            <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
              <HddOutlined style={{ fontSize: '5vh' }} />
              <div>&nbsp;</div>
              <div>Avg. Daily Token:</div>
              <div>{estDailyToken} TXT</div>
              <div>Priced in CFX (1 TXT = {priceToken} CFX):</div>
              <div>{estDailyTokenCFX} CFX</div>
              <div>&nbsp;</div>
              <Title level={4}>Est. ROI {estROI} Days</Title>
              <div>&nbsp;</div>
            </div>
          </Col>
          <Col xs={24} sm={12}>
            <Row gutter={[8, 8]}>
              {minterError}
              {rows.map((item, index) => {
                return (
                  <Col key={index} xs={12} sm={12} style={{}}>
                    <Card type='inner' title={<Title style={{ textAlign: 'center', height: '100%' }} level={5}>{item.title}</Title>}>
                      <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
                        <Space direction="vertical" align="center">
                          <Text> </Text>
                          <div style={{ textAlign: 'center' }}>Daily Token Multiplier:</div>
                          <div style={{ textAlign: 'center' }}>{item.share / 10}X</div>
                          <div style={{ textAlign: 'center' }}>Minting Fee: {item.price} {GAS}</div>
                          <Text> </Text>
                        </Space>
                        <Button type='primary' onClick={() => this.mintNFT(item.price)}>
                          MINT NFT
                        </Button>
                      </div>
                    </Card>
                  </Col>
                );
              })}
            </Row>
          </Col>
        </Row>
      </Card>
    )

  }

}

export default Dashboard;
